enum UserPermission {
  // Actions.
  AdminSetParentOrder = 'admin.setParentOrder',
  CancelPayment = 'cancelPayment',
  CapturePayment = 'capturePayment',
  ChangeOrderStatus = 'changeOrderStatus',
  CreateParcel = 'createParcel',
  CreateRefund = 'createRefund',
  ExportBarcode = 'exportBarcode',
  GetPaymentUrl = 'getPaymentUrl',
  SupplierGetSupplierAccount = 'supplier.getSupplierAccount',
  UpdateProductStock = 'updateProductStock',

  // Actions (data export).
  AdminExportAmbassadors = 'admin.exportAmbassadors',
  AdminExportBrands = 'admin.exportBrands',
  AdminExportIncreasedRatesStatistics = 'admin.exportIncreasedRatesStatistics',
  AdminExportOrders = 'admin.exportOrders',
  AdminExportOrdersStatistics = 'admin.exportOrdersStatistics',
  AdminExportPaidOrdersAndUsersStatistics = 'admin.exportPaidOrdersAndUsersStatistics',
  AdminExportProducts = 'admin.exportProducts',
  AdminExportPromoCodes = 'admin.exportPromoCodes',
  AdminExportSalesStatistics = 'admin.exportSalesStatistics',
  AdminExportSuppliers = 'admin.exportSuppliers',
  AdminExportUsers = 'admin.exportUsers',
  SupplierExportIncreasedRatesStatistics = 'supplier.exportIncreasedRatesStatistics',
  SupplierExportProducts = 'supplier.exportProducts',
  SupplierExportSalesStatistics = 'supplier.exportSalesStatistics',

  // Ambassadors.
  CreateAmbassador = 'createAmbassador',
  GetAmbassador = 'getAmbassador',
  GetAmbassadors = 'getAmbassadors',
  UpdateAmbassador = 'updateAmbassador',

  // Articles.
  CreateArticle = 'createArticle',
  GetArticleAsAdmin = 'getArticleAsAdmin',
  GetArticlesAsAdmin = 'getArticlesAsAdmin',
  UpdateArticle = 'updateArticle',
  DeleteArticle = 'deleteArticle',

  // Banners.
  AdminCreateBanner = 'admin.createBanner',
  AdminGetBanner = 'admin.getBanner',
  AdminGetBanners = 'admin.getBanners',
  AdminUpdateBanner = 'admin.updateBanner',
  AdminDeleteBanner = 'admin.deleteBanner',

  // Brands.
  AdminCreateBrand = 'admin.createBrand',
  SupplierCreateBrand = 'supplier.createBrand',
  AdminGetBrands = 'admin.getBrands',
  SupplierGetBrands = 'supplier.getBrands',
  AdminUpdateBrand = 'admin.updateBrand',
  AdminDeleteBrand = 'admin.deleteBrand',

  // Categories.
  CreateCategory = 'createCategory',
  GetCategoryAsAdmin = 'getCategoryAsAdmin',
  GetCategoriesAsAdmin = 'getCategoriesAsAdmin',
  UpdateCategory = 'updateCategory',
  DeleteCategory = 'deleteCategory',

  // Certificates.
  CreateCertificate = 'createCertificate',
  GetCertificate = 'getCertificate',
  GetCertificates = 'getCertificates',
  UpdateCertificate = 'updateCertificate',
  DeleteCertificate = 'deleteCertificate',

  // Collections.
  CreateCollection = 'createCollection',
  GetCollectionAsAdmin = 'getCollectionAsAdmin',
  GetCollectionsAsAdmin = 'getCollectionsAsAdmin',
  UpdateCollection = 'updateCollection',
  DeleteCollection = 'deleteCollection',

  // Consultations.
  AdminGetConsultations = 'admin.getConsultations',
  SpecialistGetConsultations = 'specialist.getConsultations',

  // Discount collection products.
  SupplierSyncDiscountCollectionProduct = 'supplier.syncDiscountCollectionProduct',

  // Discount collections.
  AdminCreateDiscountCollection = 'admin.createDiscountCollection',
  AdminGetDiscountCollection = 'admin.getDiscountCollection',
  AdminGetDiscountCollections = 'admin.getDiscountCollections',
  AdminUpdateDiscountCollection = 'admin.updateDiscountCollection',
  AdminDeleteDiscountCollection = 'admin.deleteDiscountCollection',
  SupplierGetDiscountCollection = 'supplier.getDiscountCollection',
  SupplierGetDiscountCollections = 'supplier.getDiscountCollections',

  // Messages.
  GetMessage = 'getMessage',
  GetMessages = 'getMessages',
  UpdateMessage = 'updateMessage',
  DeleteMessage = 'deleteMessage',

  // Orders.
  CreateBloggerOrder = 'createBloggerOrder',
  CreateRepeatOrder = 'createRepeatOrder',
  GetOrder = 'getOrder',
  GetOrders = 'getOrders',
  UpdateOrder = 'updateOrder',
  DeleteOrder = 'deleteOrder',

  // Product changes.
  AdminApproveProductChanges = 'admin.approveProductChanges',
  AdminCancelProductChanges  = 'admin.cancelProductChanges',
  AdminGetProductChanges = 'admin.getProductChanges',

  // Products.
  AdminCreateProduct = 'admin.createProduct',
  AdminGetProduct = 'admin.getProduct',
  AdminGetProducts = 'admin.getProducts',
  AdminUpdateProduct = 'admin.updateProduct',
  AdminDeleteProduct = 'admin.deleteProduct',
  SupplierCreateProduct = 'supplier.createProduct',
  SupplierGetProduct = 'supplier.getProduct',
  SupplierGetProducts = 'supplier.getProducts',
  SupplierUpdateProduct = 'supplier.updateProduct',

  // Promo code applications.
  GetPromoCodeApplication = 'getPromoCodeApplication',
  GetPromoCodeApplications = 'getPromoCodeApplications',
  UpdatePromoCodeApplication = 'updatePromoCodeApplication',

  // Promo codes.
  CreatePromoCode = 'createPromoCode',
  GetPromoCode = 'getPromoCodeAsAdmin',
  GetPromoCodes = 'getPromoCodes',
  UpdatePromoCode = 'updatePromoCode',
  DeletePromoCode = 'deletePromoCode',

  // Quality certificates.
  AdminCreateQualityCertificate = 'admin.createQualityCertificate',
  AdminGetQualityCertificate = 'admin.getQualityCertificate',
  AdminGetQualityCertificates = 'admin.getQualityCertificates',
  AdminUpdateQualityCertificate = 'admin.updateQualityCertificate',
  SupplierCreateQualityCertificate = 'supplier.createQualityCertificate',
  SupplierGetQualityCertificate = 'supplier.getQualityCertificate',
  SupplierGetQualityCertificates = 'supplier.getQualityCertificates',
  SupplierUpdateQualityCertificate = 'supplier.updateQualityCertificate',

  // Reviews.
  GetReviewAsAdmin = 'getReviewAsAdmin',
  GetReviewsAsAdmin = 'getReviewsAsAdmin',
  UpdateReviewAsAdmin = 'updateReviewAsAdmin',
  DeleteReviewAsAdmin = 'deleteReviewAsAdmin',
  SupplierAnswerReview = 'supplier.answerReview',

  // Scripts.
  UpdateProductPositions = 'updateProductPositions',
  UpdateThisWeekDiscounts = 'updateThisWeekDiscounts',

  // Special offers.
  CreateSpecialOffer = 'createSpecialOffer',
  GetSpecialOfferAsAdmin = 'getSpecialOfferAsAdmin',
  GetSpecialOffersAsAdmin = 'getSpecialOffersAsAdmin',
  UpdateSpecialOffer = 'updateSpecialOffer',
  DeleteSpecialOffer = 'deleteSpecialOffer',

  // Specialist applications.
  AdminUpdateSpecialistApplication = 'admin.updateSpecialistApplication',

  // Specialists.
  AdminCreateSpecialist      = 'admin.createSpecialist',
  AdminDeleteSpecialist      = 'admin.deleteSpecialist',
  AdminGetSpecialist         = 'admin.getSpecialist',
  AdminGetSpecialists        = 'admin.getSpecialists',
  AdminUpdateSpecialist      = 'admin.updateSpecialist',
  SpecialistCreateSpecialist = 'specialist.createSpecialist',
  SpecialistUpdateSpecialist = 'specialist.updateSpecialist',
  SpecialistCreatePromocode  = 'specialist.createPromocode',

  // Supplier applications.
  AdminGetSupplierApplication = 'admin.getSupplierApplication',
  AdminGetSupplierApplications = 'admin.getSupplierApplications',
  AdminUpdateSupplierApplication = 'admin.updateSupplierApplication',

  // Supplier FAQs.
  AdminGetSupplierFaq = 'admin.getSupplierFaq',
  AdminGetSupplierFaqs = 'admin.getSupplierFaqs',
  AdminCreateSupplierFaq = 'admin.createSupplierFaq',
  AdminUpdateSupplierFaq = 'admin.updateSupplierFaq',
  AdminDeleteSupplierFaq = 'admin.deleteSupplierFaq',
  SupplierGetSupplierFaqs = 'supplier.getSupplierFaqs',

  // Suppliers.
  AdminCreateSupplier = 'admin.createSupplier',
  AdminGetSupplier = 'admin.getSupplier',
  AdminGetSuppliers = 'admin.getSuppliers',
  AdminUpdateSupplier = 'admin.updateSupplier',
  AdminDeleteSupplier = 'admin.deleteSupplier',

  // Supply orders.
  AdminCreateSupplyOrder = 'admin.createSupplyOrder',
  AdminGetSupplyOrder = 'admin.getSupplyOrder',
  AdminGetSupplyOrders = 'admin.getSupplyOrders',
  AdminUpdateSupplyOrder = 'admin.updateSupplyOrder',
  SupplierCreateSupplyOrder = 'supplier.createSupplyOrder',
  SupplierGetSupplyOrder = 'supplier.getSupplyOrder',
  SupplierGetSupplyOrders = 'supplier.getSupplyOrders',
  SupplierUpdateSupplyOrder = 'supplier.updateSupplyOrder',

  // Product questions.
  AdminGetProductQuestion = 'admin.getProductQuestion',
  AdminGetProductQuestions = 'admin.getProductQuestions',
  AdminUpdateProductQuestion = 'admin.updateProductQuestion',
  AdminDeleteProductQuestion = 'admin.deleteProductQuestion',
  ClientCreateProductQuestion = 'client.createProductQuestion',
  SupplierAnswerProductQuestion = 'supplier.answerProductQuestion',
  SupplierGetProductQuestion = 'supplier.getProductQuestion',
  SupplierGetProductQuestions = 'supplier.getProductQuestions',

  // Tags.
  CreateTag = 'createTag',
  UpdateTag = 'updateTag',
  DeleteTag = 'deleteTag',

  // Users.
  GetUsers = 'getUsers',

  // Warehouses.
  CreateWarehouse = 'createWarehouse',
  GetWarehouse = 'getWarehouse',
  GetWarehouses = 'getWarehouses',
  UpdateWarehouse = 'updateWarehouse',
  DeleteWarehouse = 'deleteWarehouse',

  // Withdrawals.
  GetWithdrawal = 'getWithdrawal',
  GetWithdrawals = 'getWithdrawals',
  UpdateWithdrawal = 'updateWithdrawal'
}

export default UserPermission
